<template>
    <footer class="mt-20 border-t border-[var(--border)] bg-[var(--panel)] px-4 py-10">
        <div class="mx-auto grid max-w-7xl gap-8 md:grid-cols-3">
            <div>
                <h3 class="text-lg font-semibold text-[var(--text-primary)]">{{ $t('footer.brand') }}</h3>
                <p class="mt-2 max-w-md text-sm text-[var(--text-muted)]">
                    {{ $t('footer.summary') }}
                </p>
                <p class="mt-3 text-xs uppercase tracking-[0.22em] text-[var(--accent)]">{{ $t('footer.motto') }}</p>
            </div>

            <div>
                <h4 class="text-sm font-semibold uppercase tracking-[0.22em] text-[var(--text-secondary)]">{{ $t('footer.quickLinks') }}</h4>
                <ul class="mt-3 space-y-2 text-sm text-[var(--text-muted)]">
                    <li v-for="item in footerLinks" :key="item.to">
                        <router-link :to="item.to" class="transition hover:text-[var(--accent)]">{{ $t(item.labelKey) }}</router-link>
                    </li>
                </ul>
            </div>

            <div>
                <h4 class="text-sm font-semibold uppercase tracking-[0.22em] text-[var(--text-secondary)]">{{ $t('footer.social') }}</h4>
                <div class="mt-3 flex flex-wrap gap-2">
                    <a
                        v-for="social in socialLinks"
                        :key="social.labelKey"
                        :href="social.href"
                        target="_blank"
                        rel="noopener"
                        class="inline-flex items-center rounded-lg border border-[var(--border)] bg-[var(--chip-bg)] px-3 py-2 text-sm text-[var(--text-secondary)] transition hover:border-[var(--accent)] hover:text-[var(--accent)]"
                    >
                        {{ $t(social.labelKey) }}
                    </a>
                </div>
            </div>
        </div>
        <div class="mx-auto mt-8 max-w-7xl border-t border-[var(--border)] pt-4 text-xs text-[var(--text-muted)]">
            {{ $t('footer.signature', { year: actualYear }) }}
        </div>
    </footer>
</template>

<script>
import { NAV_LINKS } from '@/constants/navigation';
import { SOCIAL_LINKS } from '@/constants/socialLinks';

export default {
    name: 'FooterComponent',
    data() {
        return {
            actualYear: new Date().getFullYear(),
            socialLinks: SOCIAL_LINKS,
            footerLinks: NAV_LINKS,
        };
    }
}
</script>
